const strings = {
  en: {
    appName: 'TA Connect',
    
    aria: {
      toggleNav: 'Toggle navigation',
      collapseSidebar: 'Collapse sidebar',
      expandSidebar: 'Expand sidebar'
    },
    
    user: {
      defaultName: 'User',
      emailNotVerified: 'Email not verified'
    },
    
    navigation: {
      dashboard: 'Dashboard',
      profile: 'Profile',
      book: 'Book',
      manageBooked: 'Manage Booked',
      settings: 'Settings',
      logout: 'Logout'
    }
  },
  ar: {
    appName: 'TA Connect',
    
    aria: {
      toggleNav: 'تبديل القائمة',
      collapseSidebar: 'إخفاء القائمة الجانبية',
      expandSidebar: 'إظهار القائمة الجانبية'
    },
    
    user: {
      defaultName: 'مستخدم',
      emailNotVerified: 'البريد الإلكتروني غير مُفعّل'
    },
    
    navigation: {
      dashboard: 'الصفحة الرئيسية',
      profile: 'الملف الشخصي',
      book: 'حجز موعد',
      manageBooked: 'حجوزاتي',
      settings: 'الإعدادات',
      logout: 'تسجيل الخروج'
    }
  }
};

export default strings;
